import { Component, useCallback, useEffect, useRef } from "react";
import Lenis from "lenis";
import { trackVisit } from "@/lib/tracking";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Restaurants from "@/components/Restaurants";
import LoyalClients from "@/components/LoyalClients";
import Perks from "@/components/Perks";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import StatsPanel from "@/components/StatsPanel";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink text-bone">
          <p>Une erreur est survenue. Rechargez la page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function LandingPage() {
  const lenisRef = useRef(null);

  useEffect(() => {
    trackVisit();
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (el && lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -70, duration: 1.4 });
    } else if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div className="bg-ink text-bone min-h-screen">
      <div className="grain" aria-hidden="true" />
      <Navbar onExplore={() => scrollTo("restaurants")} />
      <main>
        <Hero
          onReserve={() => scrollTo("restaurants")}
          onExplore={() => scrollTo("restaurants")}
        />
        <Marquee />
        <LoyalClients />
        <Restaurants />
        <Perks />
        <FinalCTA onReserve={() => scrollTo("restaurants")} />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  if (window.location.hash === "#stats") {
    return (
      <ErrorBoundary>
        <StatsPanel />
      </ErrorBoundary>
    );
  }
  return (
    <ErrorBoundary>
      <LandingPage />
    </ErrorBoundary>
  );
}

export default App;
